function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
  id: "avatar-junsui-2x-secret-a",
  width: 95,
  height: 95,
  rx: 22
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "avatar-junsui-2x-secret-b",
  x1: "50%",
  y1: "0%",
  x2: "50%",
  y2: "100%"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#BAA794",
  offset: "0%"
}), /*#__PURE__*/React.createElement("stop", {
  stopColor: "#AC825B",
  offset: "57.569%"
}), /*#__PURE__*/React.createElement("stop", {
  stopColor: "#AD7E2E",
  offset: "100%"
})));

var _ref3 = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("mask", {
  id: "avatar-junsui-2x-secret-c",
  fill: "#fff"
}, /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#avatar-junsui-2x-secret-a"
})), /*#__PURE__*/React.createElement("use", {
  fill: "url(#avatar-junsui-2x-secret-b)",
  xlinkHref: "#avatar-junsui-2x-secret-a"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#FFF",
  mask: "url(#avatar-junsui-2x-secret-c)",
  d: "M36.277 44.286h-5.693c-.334 0-.543-.36-.378-.65l2.553-4.487c.155-.28.55-.297.73-.035l3.14 4.486c.204.29-.003.685-.354.685zM89 24.668v46.664C89 81.09 81.09 89 71.332 89H35.624c-.835 0-1.51-.676-1.51-1.51V53.04c0-.623.504-1.128 1.127-1.128h6.77c.895 0 1.62-.726 1.62-1.62V44.41c0-.296-.08-.584-.23-.836l-3.665-6.107c-.13-.22-.367-.352-.62-.352H35.16c-.556 0-.905-.6-.63-1.084l6.965-12.237c.34-.6-.093-1.344-.783-1.344h-5.85c-.306 0-.59.154-.756.41l-4.903 7.572c-.212.33-.69.337-.913.016l-2.378-3.414c-.287-.413-.312-.953-.064-1.39l4.608-8.118c.323-.567-.087-1.27-.74-1.27h-6.452c-.306 0-.588.163-.74.43L17.47 25.56c-.2.353-.306.752-.306 1.158v1.867c0 .5.16.99.46 1.393l5.668 7.653c.402.543.425 1.276.058 1.843l-2.636 4.072c-.298.46-.81.74-1.358.74H17.37c-.725 0-1.314.587-1.314 1.313v4.997c0 .726.59 1.315 1.315 1.315h7.336c.622 0 1.127.505 1.127 1.127v34.436c0 .842-.692 1.522-1.534 1.51-.314-.005-.583-.01-.695-.017C14.355 88.416 7 80.716 7 71.33V24.67C7 14.91 14.91 7 24.67 7h31.42c1.325 0 2.4 1.075 2.4 2.4v10.734c0 .498-.39.912-.89.94-4.417.24-8.32.242-10.24.223-.693-.007-1.255.553-1.255 1.247v5.54c0 .7.572 1.264 1.272 1.247 1.92-.045 5.795-.16 10.12-.39.537-.03.99.4.99.938V52.63c0 .467-.378.846-.846.846h-3.26c-.466 0-.846-.38-.846-.847V35.926c0-.856-.693-1.55-1.55-1.55H48.5c-.855 0-1.55.694-1.55 1.55v31.186c0 .855.695 1.55 1.55 1.55h3.484c.857 0 1.55-.695 1.55-1.55v-4.838c0-.468.38-.848.848-.848h3.26c.467 0 .846.38.846.848v9.712c0 4.302 1.827 7.496 4.63 7.496h11.667c3.324 0 5.8-.652 5.8-3.585v-5.284c0-.707-.792-1.13-1.37-.725-1.042.73-2.662 1.51-4.82 1.51H67.93c-.75 0-1.358-.608-1.358-1.357v-7.768c0-.468.38-.848.847-.848h2.87c7.755 0 9.32-3.39 9.32-7.82V35.423c0-.72-.586-1.307-1.307-1.307h-5.73c-.722 0-1.307.586-1.307 1.307V52.63c0 .467-.38.846-.848.846h-3c-.467 0-.846-.38-.846-.847V29.126c0-.483.37-.887.85-.936 5.868-.595 9.908-1.255 11.685-1.573.594-.106 1.022-.623 1.022-1.227v-5.41c0-.76-.666-1.342-1.417-1.236-2.183.31-6.592.915-11.096 1.434-.557.064-1.046-.373-1.046-.934V9.4c0-1.325 1.075-2.4 2.4-2.4h2.36C81.09 7 89 14.91 89 24.668zM14.77 72.654c-.112.928.612 1.746 1.547 1.746h3.407c.586 0 1.08-.438 1.15-1.02l1.818-15.095c.112-.928-.613-1.745-1.548-1.745h-3.407c-.586 0-1.08.437-1.15 1.02L14.77 72.653zm28.795-14.746c0-.828-.67-1.498-1.5-1.498h-3.39c-.827 0-1.498.67-1.498 1.498v13.755c0 .827.67 1.498 1.498 1.498h3.39c.83 0 1.5-.67 1.5-1.496V57.908z"
}));

var SvgJunsui = function SvgJunsui(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 95,
    height: 95,
    viewBox: "0 0 95 95",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgJunsui, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/junsui.8ddf8b18.svg";
export { ForwardRef as ReactComponent };